import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function Pill({ availabilityLoaded, availability, sizeToRender, selectedSize, handleSelect }) {
  let dataTestId;
  const [isSizeDisabled, setSizeAsDisabled] = useState(true);

  useEffect(() => {
    if (availabilityLoaded && Array.isArray(availability)) {
      const availableCountForSku = availability?.find(o => o?.sku === sizeToRender?.sku)?.availableCount;
      setSizeAsDisabled(!(Number.isInteger(availableCountForSku) && availableCountForSku > 0));
    }
  }, [availabilityLoaded, availability]);

  let buttonClassName = "relative px-4 py-2 border rounded-md overflow-hidden";

  if (isSizeDisabled) {
    buttonClassName += " text-lightGray";
  } else {
    buttonClassName += " border-lighterGray hover:bg-gray-200 cursor-pointer";

    if (selectedSize === sizeToRender) {
      buttonClassName += " bg-wine-100 text-wine border-wine hover:bg-wine-100";
    }
  }

  if (isSizeDisabled && availabilityLoaded) {
    dataTestId = "size-pill-unavailable";
  } else if (availabilityLoaded) {
    dataTestId = "size-pill-available";
  } else {
    dataTestId = "size-pill-loading";
  }

  return (
    <button
      key={sizeToRender.sku}
      onClick={() => handleSelect(sizeToRender)}
      className={buttonClassName}
      data-test-id={dataTestId}>
      <p className="relative">{sizeToRender.sizeDisplayText}</p>
      {isSizeDisabled && availabilityLoaded && (
        <svg className="absolute top-0 left-0 w-full h-full pointer-events-none">
          <line x1="-2px" y1="100%" x2="100%" y2="2px" stroke="lightGray" strokeWidth="1"></line>
        </svg>
      )}
    </button>
  );
}

Pill.propTypes = {
  sizeToRender: PropTypes.shape({
    sku: PropTypes.string,
    sizeDisplayText: PropTypes.string,
  }).isRequired,
  selectedSize: PropTypes.object,
  availability: PropTypes.arrayOf(
    PropTypes.shape({
      sku: PropTypes.string,
      availableCount: PropTypes.number,
    })
  ),
  availabilityLoaded: PropTypes.bool.isRequired,
  handleSelect: PropTypes.func,
};
